export default {
  common: {
    querySpecifications: 'Query technical specifications',
    login: 'Sign In',
    logout: 'Sign Out',
    Home: 'ホーム',
    ProductCenter: '製品一覧',
    WhatIsaSoftwareDefinedCamera: 'What Is a Software-Defined Camera',
    ProductDetail: 'Product Detail',
    Solutions: 'Solutions',
    SolutionsDetail: 'Solutions Detail',
    Products: 'Products',
    Tools: 'Tools',
    Support: 'Support',
    Documentation: 'Documentation',
    news: 'News Center',
    newsDetail: 'News Detail',
    forPartners: 'For Partners',
    activity:'Activity',
    SoftwareDefinedCamera: 'Software-Defined Camera',
    IntelligentVisionSystem: 'IVS',
    Accessory: 'Accessory',
    ContactUs: 'Contact Us',
    NewsRoom: 'ニュースルーム',
    NewsRoomDetail: 'News Room Detail',
    Partner: 'Partner',
    Resources: 'Resources',
    ResourceCenter: 'Resource Center',
    VideoLibrary: 'Video Library',
    AftersalesSupport: 'Aftersales Support',
    Aftersales: 'Aftersales Q&A',
    Privacy: 'Privacy',
    TermsOfUse: 'Terms of use',
    clear:"Clear",
    RefineBy: '絞り込み',
    placeholder: 'Enter the model, name, or keyword',
    Favorites: 'Favorites',
    Compare: 'Compare',
    More: 'More',
    all: 'すべて',
    enter: 'モデル、名前、またはキーワードを入力してください',
    enterKeyword: 'キーワードを入力',
    resultsFound: '検索結果: ',
    collapse: '折りたたむ ',
    expand: 'さらに表示',
    confirm:"Confirm",
    cancel:"Cancel",
    channel:"パートナーマップ",
    type: 'タイプ',
    upload: "アップロード",
    submit: 'ログイン',
    activityHub:'活動ハブ',
    search: '検索',
  },
  login: {
    title: 'Sign In with User ID',
    email: 'Email',
    pwd: 'Password',
    changePwd: 'Change Password',
    forgetPwd: 'Forget Password',
    register: 'Register',
    rulesEmail: 'Email is invalid',
  },
  //导航栏
  navbar: {
    aboutTitle: '企業情報',
    about: '会社紹介',
    products: '製品情報',
    productCenter: 'PRODUCT CENTER',
    technicalSupport: 'サポート',
    FAQ:'FAQ',
    solution: 'ソリューション情報',
    documentation: 'ドキュメンテーション',
    support: 'サポート',
    certificate: '認証',
    pocDemo: 'PoC Demo',
    news: 'ニュースリリース',
    activityHub: '活動ハブ', 
    events:'EVENTS',
    tools: 'TOOLS',
    partners: 'パートナー',
    resources: 'リソース',
    forPartners: 'パートナー開発',
    forCustomers: 'FOR CUSTOMERS',
    channel:"パートナーマップ",
    videoLibrary: "動画ライブラリ",
    contact: "お問い合わせ",
    // algorithmstore: "ALGORITHM STORE",
    algorithmstore: "アルゴリズムショップ",
    terms: "POLICIES, TERMS, CONDITIONS",
    warrantypolicy: "WARRANTYPOLICY",
    firmware: "ファームウェア",
    software: "ソフトウェア",
    becomeAPartner: 'パートナー申請',
    dealRegistration: 'パートナー案件の登録',
    training: 'ラーニング',
    knowledge: 'Knowledge',
    successfulCases: 'Success Stories'
  },
  home: {
    'whatIsNew': "新着情報",
    'ProductSpotlight': '製品スポットライト',
    'Events&News': 'イベント&ニュース',
    'learnMore': '詳しくはこちら',
    'e-learning': 'ラーニング',
    'certificate': '認証',
    'video': 'ビデオ',
    'wiki': 'ウィキ'
  },
  //合作伙伴
  partners:{
    banner:{
      title:'HOLOWITS認定',
      summery:'インテリジェントビジョンスペシャリスト',
    },
    introduction:{
      title:'オンライン授業の概要',
      desc:'このコースでは、HOLOWITSソフトウェア定義カメラ（SDC）、ネットワークビデオレコーダー（NVR）、インテリジェントマイクロエッジデバイス、およびソリューションの全シリーズを紹介します。プリセールスとアフターセールスの知識をカバーするさまざまな学習教材と試験を提供します。試験に合格すると、HOLOWITS Certified Intelligent Vision Specialistの資格を取得できます。',
    },
    course:{
      title:'コース概要',
      value:'このコースでは、HOLOWITSの製品とソリューションのハイライトについて学び、プリセールススキルを習得し、顧客に専門的なポストセールスサービスを提供するのに役立ちます。',
    },
    certification:{
      title:'認証の価値',
      value:'この証明書は、市場での競争力を高め、ホロイッツの製品、ソリューション、アフターサービスにおける専門知識を示し、顧客や雇用主が専門的な能力を簡単に識別できるようにするものです。',
    },
    contents:[
      {text: 'HOLOWITS AIカメラ技術発表会'},
      {text: 'HOLOWITS AIビデオプラットフォーム技術プレゼンテーション'},
      {text: 'HOLOWITS HWT-NVR800 テクニカルメインスライド'},
      {text: 'HOLOWITS iClient S100テクニカルトレーニング'},
      {text: 'HOLOWITSアクセサリ構成ガイド'},
      {text: 'HOLOWITS インテリジェントリテールソリューション'},
      {text: 'HOLOWITS インテリジェントキャンパスソリューション'},
      {text: 'HOLOWITS インテリジェントグリッドソリューション'},
      {text: 'HOLOWITS インテリジェント輸送ソリューション'},
      {text: 'HOLOWITS S200テクニカルトレーニング'},
      {text: 'ターゲットキャプチャカメラのサイト調査とコミッショニングのクイックガイド'},
      {text: 'ePOLICEカメラのサイト調査とコミッショニングのクイックガイド'},
      {text: 'HOLOWITS HWT-NVR800の設置とコミッショニング'},
      {text: 'HOLOWITS HWT-IVS1800の設置とコミッショニング'},
      {text: 'HOLOWITS AシリーズカメラとXVRの紹介'},
      {text: 'HOLOWITS APP取扱説明書'},
      {text: 'HOLOWITS Eシリーズカメラの紹介'},
    ],
    learningGuide:{
      title:'学習ガイド',
      desc:'試験に合格するには、関連する資料やビデオを注意深く勉強する必要があります。認証取得後は、2年ごとに証明書を更新する必要があります。',
      text:'初回ログインには登録が必要です',
      registerCode:'Registration code: ',
      registerValue:'UJIQ-RVH-PQW',
      btnValue:'Start Exam',
    },
  },
  //关于Holowits
  aboutHWT:{
    label: {
      'Company Profile': '会社概要',
      'Who is HOLOWITS': 'HOLOWITSとは',
      'HOLOWITS Offering': 'HOLOWITS沿革',
      'Business Overview': '事業概要',
      'Culture & Value': '文化と価値',
      'Quality Policy': '品質方針',
      'Data Security': 'データセキュリティ',
      'Cyber Security': 'サイバーセキュリティ',
      'Sustainable Development': 'サステナブルな開発',
    },
    one: {
      wshtw: `HOLOWITSとは`,
      ov: `私たちのビジョン`,
      title1: `インテリジェントな世界のためのすべてのセンシング`,
      title2: `私たちについて`,
      content: `HOLOWITSは、多次元認識技術に基づくインテリジェントなモノのインターネット（AIoT）製品およびソリューションのグローバルプロバイダーであり、研究開発、生産、流通、販売、サービスなどの幅広い機能を統合しています。HOLOWITSは、インテリジェントなセンシング技術、本格的な産業チェーン、強力な技術サポート能力に恵まれています。増え続けるインテリジェンスに対する世界的な需要に対応するため、ホロイッツはAIカメラ（AIC）、ビデオインテリジェントプラットフォーム（VIP）、クラウドサービスの開発に取り組んでいます。これらのサービスは、インテリジェントシティ、インテリジェント交通、インテリジェントエネルギー、インテリジェント製造、インテリジェントキャンパス、インテリジェント小売など、さまざまなシナリオに適用できます。私たちは、すべてのものをセンシングするインテリジェントな世界を構築するために協力することを目指しています。これを達成するために、私たちは安全で信頼性が高く、使いやすく、優れた製品とソリューションをグローバル市場に提供することに専念しています。`
    },
    two: {
      content1: `HOLOWITS沿革`,
      content2: `IPCからAICへの関与`,
      content3: `ソフトウェアデファインドアーキテクチャ、「機能カメラ」から「スマートカメラ」への変革`,
      content4: `1960年代のアナログカメラ`,
      content5: `光学および電気機械`,
      content6: `1990年代のIPカメラ`,
      content7: `専用カメラ1台`,
      content8: `2020年代AIカメラ`,
      content9: `AIを活用した常時オンのインテリジェンス`,
      content10: `レガシーカメラ`,
      content11: `限られた計算能力`,
      content12: `AIカメラ`,
      content13: `AIカメラ技術の軌跡は、フィーチャーフォンからスマートフォンへの進化と非常に似ていると強く主張します。実質的な進歩と革命的な能力を特徴とするこの変革は、AIカメラ分野を新たな高みに押し上げ、視覚的イメージングの風景を根本的に再形成する運命にあると考えています。`,
      content14: `AI ROOTテクノロジーズ`,
      content15: `HOLOWITSが業界でユニークな理由は何ですか？`,
      content16: `インテリジェント・センシングの分野では、HOLOWITSは高度なAIルート・テクノロジーを所有しています。`,
      content17: `AI ROOT Technologiesに基づく製品`,
      // content18: `SuperColor`,
      // content19: `Challenges`,
      // content20: `Light compensation is required under low-lit conditions`,
      // content21: `Traditional ISP optimization has reached the bottleneck`,
      // content22: `Interferences caused by rain and dust lead to poor-quality images`,
      // content23: `Crystal-clear night visioin with 0 light pollution`,
      content99: `AIカメラとプラットフォームを使用して、ホロイッツはパートナーと協力して、さまざまな顧客向けにインテリジェント輸送、都市、キャンパス、小売りのソリューションを開発し、効率的な管理、サービス革新、ビジネスの成功を実現します。HOLOWITSは、あらゆるものが感知できる世界を構築し、仕事と生活をより簡単かつスマートにするのに役立つ製品とサービスを継続的に提供しています。`
    },
    three: {
      content1: `事業概要`,
      content2: `事業マップ`,
      content3: `HOLOWITSでは、強力で効率的な流通ネットワークの重要性を理解しています。当社のグローバル展開は、世界中のお客様が当社の革新的な製品を利用できるようにするという当社のコミットメントの証です。`,
      content4: `当社の流通ネットワークは大陸にまたがっており、ディストリビューターは世界中の主要市場に戦略的に配置されています。この広範なネットワークにより、当社は迅速かつ効率的に製品を提供し、お客様が可能な限り最高のサービスを受けられるようにします。`,
      content5: `パートナーズウォール`,
      content6: `HOLOWITSは、流通ネットワークの拡大と強化に継続的に取り組んでいます。私たちは、世界の隅々にまでリーチし、革新的で持続可能でエネルギー効率の高いソリューションを世界中のお客様に提供することをお約束します。私たちとの提携に興味を持っている潜在的な販売代理店であろうと、私たちの製品を探している顧客であろうと、よりインテリジェントで持続可能な世界を創造するための私たちの旅に参加してください。`,
    },
    four: {
      content1: `文化と価値`,
      content2: `HOLOWITSは、多様性を受け入れることによって創造性と革新が育まれると確信しているため、多様で包括的な環境の創造に努めています。`,
      content3: `私たちは新しい視点を歓迎し、新しい課題を受け入れ、革新に努める個人に機会とサポートを提供することにコミットしています。`,
      content4: `HOLOWITSで働くことは、ダイナミックなチームの一員であり、最先端の技術を生み出し、活用するために緊密に協力することを意味します。また、個人的および専門的な成長の場でもあり、熟練した専門家としても個人としても成長する機会が豊富にあります。`,
    },
    five: {
      content1: `品質方針`,
      content2: `HOLOWITSは、最高品質の製品とサービスをお客様に提供することをお約束します。私たちの品質保証プロセスは厳格で包括的であり、私たちが提供するすべての製品が私たちの高い基準を満たしていることを保証します。`,
      content3: `私たちは、大手グローバル企業のIBMに触発された高度な品質管理システムを採用しています。これらのシステムは、当社の製品開発、生産、サービスプロセスをガイドし、あらゆる段階で一貫性と卓越性を確保します。`,
      content4: `品質に対する当社のコミットメントは、国際基準の遵守によってさらに実証されています。当社は、品質管理に関するISO9001、環境管理に関するISO14000、労働安全衛生に関するISO45000、ITサービス管理に関するISO20000、情報セキュリティ管理に関するISO27000の認証を取得していることを誇りに思っています。これらの認証は、品質、安全性、持続可能性に対する当社の献身を反映しています。`,
      content5: `HOLOWITSでは、品質とは単に基準を満たすことではなく、期待を超えることです。私たちは、可能な限り最高の体験をお客様に提供するために、製品、サービス、プロセスの改善に継続的に取り組んでいます。`,
    },
    six: {
      content1: `データセキュリティ`,
      content2: `HOLOWITSでは、お客様のデータを保護することは単なる責任ではなく、最優先の取り組みです。ここでは、データセキュリティを確保するための包括的なアプローチについて詳しく説明します。`,
      content3: `グローバルクラウドサービスインフラストラクチャ：当社のデータセンターは1つの地域に限定されていません。シンガポール、UAE、ブラジル、南アフリカ、アイルランドの5つの主要なクラウドノードを世界中に設置しています。このグローバルなプレゼンスは、アクセシビリティと効率性を向上させるだけでなく、予期せぬローカルな大惨事に備えてデータの冗長性とリカバリを保証します。`,
      content4: `保護のための設計：当社のデータセンターは、ユーザーデータ保護を重視した建築の傑作です。各施設には、物理的セキュリティ、環境管理、災害への備えに関する最新の進歩が組み込まれています。この強固な基盤は、当社の革新的なソフトウェア対策と相まって、当社のインフラストラクチャは業界で最も安全なものの1つになっています。`,
      content5: `法的コンプライアンスとその先：私たちは、ノードが配置されているすべての国の法律と規制を厳密に遵守していますが、それだけではありません。データセキュリティとプライバシーに対する当社の取り組みは、多くの場合、単なる法的コンプライアンスを超えています。それは、ユーザーの信頼を獲得し、維持することです。`,
      content6: `高度な暗号化プロトコル：暗号化は私たちにとって後付けではなく、標準です。最先端の暗号化方法を採用しており、転送中でも保存中でも、機密データを不正な詮索好きな目から確実に保護します。`,
      content7: `積極的な脅威の検出と対応：HOLOWITSでは、最善の防御は優れた攻撃であると考えています。したがって、当社のシステムは常に異常や潜在的な脅威を監視しています。シスコの高度な脅威検出機能により、対応を待つだけでなく、脅威が顕在化する前に積極的に特定して無力化しています。`,
      content8: `24時間365日のセキュリティ監視：毎日、重要なデータ領域は厳格な監視下に置かれています。異常なアクティビティが発生すると、当社の堅牢なインシデント対応プロトコルがトリガーされ、迅速なアクションが保証され、潜在的な影響が最小限に抑えられます。`,
      content9: `継続的な改善：サイバー脅威のダイナミックな世界では、自分の栄誉に頼ることはできません。私たちは、システム、プロセス、技術を強化するための継続的な旅に取り組んでいます。定期的な監査、ペネトレーションテスト、トレーニングセッションにより、HOLOWITSがデータ保護技術の頂点にいることを保証します。`,
    },
    seven: {
      content1: `サステナブルな開発`,
      content2: `HOLOWITSでは、当社の事業戦略と技術革新に深く根ざした原則である持続可能な開発に取り組んでいます。私たちは、お客様のニーズに応えるだけでなく、環境にも積極的に貢献するソリューションを創造することを信じています。`,
      content3: `私たちの持続可能性へのコミットメントは、人工知能（AI）の先駆的な使用に反映されています。私たちはAIの力を活用して、革新的であるだけでなく、環境に優しい製品を開発してきました。当社のコアAI技術であるSuperColor、SuperCoding、SuperAIは、この取り組みの代表的な例です。`,
      content4: `SuperColor技術により、当社のAIカメラは、追加の照明を必要とせずに、鮮やかなフルカラー画像を撮影できます。この革新的なアプローチは、光害を減らし、エネルギーを節約し、よりグリーンで持続可能な環境に貢献します。`,
      content5: `もう1つの重要な技術であるSuperCodingは、ビデオの伝送と保存を最適化します。ビデオをフォアグラウンドとバックグラウンドに分離し、ダイナミックフォアグラウンドに通常のコーディングを適用し、バックグラウンドに深度コーディングを適用します。このプロセスにより、伝送帯域幅とストレージの必要性が約60%削減され、大幅なエネルギー節約が可能になります。`,
      content6: `SuperAIを使用すると、当社のAIカメラの1 TOPSのコンピューティングパワーは、業界の2 TOPSに相当し、リソースを節約できます。同時に、当社のオープンアルゴリズムエコシステムにより、カメラはアルゴリズムを自由に切り替えることができます。1台のAIカメラで、業界で複数のカメラを必要とする要求を満たすことができます。`,
      content7: `企業の観点からは、環境に配慮したエネルギー効率の高いソリューションの創出を目指しています。たとえば、当社のエコキューブカメラは、ネットワークや電源ケーブルを必要とせず、材料の使用量とエネルギー消費量を削減します。さらに、その設計により、デバイスのメンテナンスのために余分な人的資源が不要になり、環境フットプリントがさらに削減されます。`,
      content8: `HOLOWITSでは、持続可能な開発は単なる流行語ではなく、ビジネス上の意思決定を形成し、イノベーションを推進する指針となっています。私たちは、テクノロジーと持続可能性が両立する未来を創造し、より健康的な地球とすべての人にとってより明るい未来に貢献することに専念しています。`,
    },
    eight: {
      content1: `サイバーセキュリティ`,
      content2: `HOLOWITSは、顧客や企業にとってのサイバーセキュリティの重要性を理解しており、世界をリードするサイバーセキュリティ基準、特にNational Vulnerability Database（NVD）基準に厳密に準拠しています。ホロイッツは、安全で信頼性の高い製品ソリューションの提供に取り組んでいます。さらに、HOLOWITSは高度なサイバーセキュリティ技術を持ち、サイバーセキュリティを最も重要なものと見なしています。HOLOWITSは、製品の新しいソフトウェアバージョンをリリースするたびに、考えられるすべての脆弱性をスキャンし、検出された各脆弱性をタイムリーに修正します。これらの修正に関する詳細は、透明性とトレーサビリティを確保するために、公式ドキュメントに保存されています。これまでのところ、市場に出回っている当社の製品には脆弱性はありません。なぜなら、製品を発売する前に、考えられるすべての脆弱性をスキャンしてクリアしたからです。`,
      content3: `HOLOWITSは、NVD標準に厳密に準拠し、NVDのウェブサイトで公開されているすべての脆弱性を適時に修正して、製品にそのような脆弱性がないことを保証します。これは、サイバーセキュリティに対する当社のコミットメントを示すだけでなく、お客様のサイバーセキュリティを非常に重視していることを示しています。要約すると、HOLOWITSは常にサイバーセキュリティを第一に考えています。技術革新と厳格な管理措置を使用することにより、HOLOWITSはその製品とサービスがお客様に確実な保証を提供できることを保証します。`,
    }
  },
  // 产品中心
  products: {
    productTypes: '製品タイプ',
    filters: {
        'All': 'すべて',
        'AI_Camera': 'AIカメラ',
        'Video_Intelligent_Platform': 'ビデオインテリジェントプラットフォーム',
        'IP_Camera_&_NVR': 'IPカメラ&NVR',
        'Analog_Camera_&_XVR': 'アナログカメラ&XVR',
        'Transmission': '伝送',
        'Display_&_Control': '表示と制御',
        'Professional_Sound': 'プロフェッショナルサウンド',
        'Entrance_&_Exit_Management': '入退管理',
        'Public_Address': 'パブリックアドレス',
        'Intelligent_Collaboration': 'インテリジェントコラボレーション',
        'Management_System': '管理体制',
        'Alarm': 'アラーム',
        'Accessories': 'アクセサリー',
        'HOLOWITS_Selected': 'HOLOWITS Selected',
        'HOLOWITS_Souvenir': 'HOLOWITS Souvenir',
        'Box_Camera': 'ボックスカメラ',
        'Bullet_Camera': 'バレットカメラ',
        'Fixed_Dome_Camera': '固定ドームカメラ',
        'PTZ_Dome_Camera': 'PTZドームカメラ',
        'AR_Panorama_Camera': 'ARパノラマカメラ',
        'Distribution/Project': 'ディストリビューション/プロジェクト',
        'AI_Function': 'AI機能',
        'Sensor_Size': 'センサーサイズ',
        'Focal_Length': '焦点距離',
        'Illuminator_Type': 'イルミネータータイプ',
        'Illumination_Distance': '照明距離',
        'IP_Rating': 'IP等級',
        'IK_Rating': 'IK等級',
        'Port': 'ポート',
        'Resolution': '解像度',
        'SuperCoding': 'スーパーコーディング',
        'Vehicle_Analysis': '車両分析',
        'Object_Classification': 'オブジェクト分類',
        'Omni-data_Structuring': 'オムニデータ構造化',
        'Auto_Tracking': '自動追跡',
        'Behavior_Analysis': '行動分析',
        'Multi-algorithm_Switchover': 'マルチアルゴリズムスイッチオーバー',
        'Target': 'ターゲット',
        'Traffic_Flow_Statistics': 'トラフィックフロー統計',
        'Vehicle_Event_Detection': '車両イベント検出',
        'Crowd_Flow_Analysis': '群集フロー分析',
    },
    sort: 'Sort',
    overAll: 'Overall',
    hot: 'Hot',
    latest: 'New',
    listPrice: 'List Price',
    preSales: 'Pre-Sales',
    model: 'Model',
    processor: 'Processor',
    memory: 'Memory',
    computingPower: 'Computing',
    Series: 'シリーズ名',
    Form: 'フォーム',
    More: 'もっと見る',
  },
  // 产品详情
  productDetail: {
    productDetail: 'Details',
    accessoryDetail: 'accessoryDetails',
    specifications: 'Specifications',
    certification: 'Certification',
    introduction: 'Introduction',
    download: 'Download',
    documentation: 'Documentation',
    huaweiCcsc: 'imgs/product_detail/mapen.png',
    clickHere: 'Click Here',
    dataSheet: 'Datasheet',
    afterSalesDocuments: 'After-Sales Documents',
    copy: 'Copy',
    reportError: 'Report Error',
    description: 'Description',
    describeError: 'Please describe the error you found.',
    picture: 'Picture',
    onlyJpg: 'Only the .jpg format is supported.',
    attachment: 'Attachment',
    selectFile: 'Select File',
    anonymous: 'Anonymous',
    submit: 'Submit',
    accessory: 'Accessory',
    technicalSpec: 'Technical Spec',
    dimensions: 'Dimensions',
    remarks: 'Remarks',
    optionalFitting: 'Optional Fitting',
    favorites: 'Favorite',
    keySpec: 'Key Spec',
    viewAll: 'Log In to View All',
    clicktoLoad: 'Download',
    completeSpecificationList: 'Complete Specification List',
  },
  // solutions
  solutions: {
    Industry: '産業分野',
    Region: '地域別',
    Type: 'タイプ',
    Solution: 'ソリューション',
    successStories: '成功事例',
    filters: {
      'Campus Sensing': 'キャンパスセンシング',
      'Transportation Sensing': '輸送センシング',
      'City Sensing': '都市センシング',
      'Africa': 'アフリカ',
      'Asian Pacific': 'アジア太平洋',
      'Europe': 'ヨーロッパ',
      'Latin America': 'ラテンアメリカ',
      'Middle East': '中東地域',
      'Other': 'その他地域',
    }
  },
  // knowledge
  knowledge: {
    "Type": "タイプ",
    "All": "すべて",
    "HOLOWITS Academy": "HOLOWITSアカデミー",
    "Industrial Knowledge": "産業知識",
    "HOLOWITS AIoT": "HOLOWITS AIoT",
    "Solution": "ソリューション"
  },
  // 技术支持
  support: {
    wahtDoYouNeedHelpWith: 'What do you need help with?',
    title: 'Welcome to HOLOWITS Technical Support',
    explain: 'HOLOWITS Technical Support provides first-class support for your HOLOWITS products and solutions. Our online support services and engineers around the world are ready to help you anytime, anywhere.',
    documentation: 'Documentation',
    softwareDownload: 'Software Download',
    video: 'Video',
    searchPlaceholder: 'キーワードを入力',

    "HOLOWITS_Support": 'HOLOWITSサポート',
    "Wiki": 'ウィキ',
    "Firmware": 'ファームウェア',
    "Software": 'ソフトウェア',
    "Knowledge": '知識',
    "E-learning": 'eラーニング',
    "Policy,Terms": 'ポリシー,規約',
    "Announcement": 'お知らせ',
    "AI Camera": 'AIカメラ',
    "Video Intelligent Platform": 'ビデオインテリジェントプラットフォーム',
    "IP Camera & Analog Camera": 'IPカメラ&アナログカメラ',
    "NVR & XVR": 'NVRとXVR',
    "Software": 'ソフトウェア',
    "Cloud Service": 'クラウドサービス',
    "Solution": 'ソリューション',
    "Other": 'その他',
    "Tools": 'ツール',
    "Calculate Bandwidth": '帯域幅の計算',
    "Calculate Recording Capacity": '記録容量の計算',
    "NVR Access": 'NVRアクセス',
    "Calculate Cameras Detection Distance": 'カメラの検出距離を計算する',
    "IP System Design Tool": 'IPシステム設計ツール',
    "MD5 Checker": 'MD5チェッカー',
  },
  contact: {
    theme: '技術サポートが必要ですか？',
    content: '技術サポートについては、お住まいの国または地域のHOLOWITS正規販売代理店にお問い合わせください。',
    tip1: 'HOLOWITSの販売代理店およびリセラーへのお問い合わせ',
    tip2: '技術サポートに関するHOLOWITSへのお問い合わせは、以下のメールアドレスまでご連絡ください。',
    tip3: '採用に関するHOLOWITSへのお問い合わせは、以下のメールアドレスまでご連絡ください。',
    button1: 'Click here',
    button2: 'support@holowits.com',
    button3: 'hr@holowits.com',
    title: '',
    explain: '',
    tip4_1: '香港支店：HOLOWITS TECHNOLOGIES HK LIMITED',
    tip4_2: '住所：香港ワンチャイヘネシー通り253-261番EASEY COMMビル10階1002号室',
    tip4_3: 'メール：support@holowits.com',
  },
    // 渠道中心
  channel: {
    partnerName: 'パートナー名',
    countryOrRegion: '国/地域',
    partnerType: 'パートナータイプ',
    searchPlaceholder:"パートナーリストで検索",
    website: 'Web Site',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    partners: {
      "Distributor": "販売代理店",
      "Reseller": "リセラー",
      "System Integrator": "システムインテグレーター",
      "All": "すべて",
      "Comprehensive Distributor": "総合ディストリビューター",
      "Project-based Distributor": "プロジェクトベースのディストリビュータ",
      "Certified Service Partner": "認定サービスパートナー",
      "Commercial Gold Partner": "コマーシャルゴールドパートナー",
      "Commercial Silver Partner": "コマーシャルシルバーパートナー",
      "Industry Gold Partner": "業界ゴールドパートナー",
      "Industry Silver Partner": "業界シルバーパートナー",
    }
  },
  // 新闻中心
  news: {
    searchPlaceholder: 'キーワードを入力',
    search: '検索',
  },
  // 客户举办的活动
  activityHub: {
    title: '活動ハブ',
    smallTitle: 'パートナーの活動、ソーシャルスポット、コミュニティの瞬間'
  },
  // 安防工具
  securityTools: {
    cameradetectionDistance: 'カメラの検出距離を計算する',
    disable: 'Disable',
    enable: 'Enable',
    videoResolution: 'Video Resolution',
    encodingBitRate: 'Encoding Bit Rate',
    NumberOfNVRs: 'Number of NVRs',
    NumberOfSDCs: 'Number of SDCs',
    microCheckpoint: 'Micro checkpoint',
    ePoliceCheckpoint: 'ePolice/Checkpoint',
    targetDetection: 'Target detection/recognition',
    calculateBandwidth: '帯域幅の計算',
    calculateRc: '記録容量の計算',
    NVRAccess: 'NVRアクセス',
    ipTools: 'IPシステム設計ツール',
    md5: 'MD5チェッカー',
    //提示信息
    microResolutionTips: 'マイクロチェックポイントモードでは、ナンバープレートの解像度は少なくとも80ピクセルにすることをお勧めします。',
    microInstallationTips: '車線シナリオでは、設置高さが4.5メートルから6メートルの範囲であることをお勧めします。キャンパスの出入口では、設置高さは1.3 m ~ 1.5 mを推奨します。設置高さは、現場の要件に基づいて設定できます。',
    ePoliceResolutionTips: 'In ePolice mode, the license plate resolution must be greater than or equal to 100 pixels. In checkpoint mode, if only license plates need to be captured, the license plate resolution must be greater than or equal to 100 pixels. If targets inside vehicles also need to be captured, the license plate resolution must be greater than or equal to 180 pixels. ',
    ePoliceInstallationTips: 'The recommended installation height ranges from 5.5 m to 6.5 m.',
    targetResolutionTips: 'Target detection: For short-focus (less than 12 mm) cameras, the recommended target resolution is at least 80 pixels. For medium- and long-focus (12 mm or more) cameras, the recommended target resolution is at least 120 pixels. Target recognition: For short-focus (less than 12 mm) cameras, the recommended target recognition is at least 110 pixels. For medium- and long-focus (12 mm or more) cameras, the recommended target resolution is at least 120 pixels.',
    targetInstallationTips: 'Target detection: For cameras with a fixed focal length of 2.8 mm or 3.6 mm, the recommended installation height ranges from 2 m to 2.5 m. For cameras with a fixed focal length of 6 mm, the recommended installation height ranges from 2 m to 3 m. For cameras with other focal lengths, the recommended installation height ranges from 2.5 m to 3.5 m. Target recognition: For short-focus cameras, the recommended installation height ranges from 2.5 m to 3 m. For long-focus cameras, the recommended installation height ranges from 2.5 m to 3.5 m.',
  },

  // 提示信息
  tipInfo: {
    exportFailure: 'Export failure.',
    addProToComp: 'Add the product to compare.',
    selectLeastTwo: 'Select at least two products for comparison.',
    selectMaximum: 'You can select a maximum of four products for comparison.',
    copySuccess: 'Copy success.',
    noData: 'No data.',
    selectOther: 'The selected device is no data. Please select another device.',
    onlyJpg: 'Only JPG images are supported.',
    exeNoUpload: 'EXE files cannot be uploaded.',
    problemNotEmpty: 'The problem description cannot be empty.',
    submitSuccess: 'Submitted successfully.',
    submitFailed: 'Submission failed. Try again later.',
    loginSuccess: 'Login success',
    errorPwd:'The two passwords are inconsistent',
    confirmLogout:'Confirm to exit the current account?',
    tooManyRequest:'Getting the authentication code is too frequent. Please try again in 3 minute',
    getCodeImageFailed:'Failed to get image verification code',
  },
  technologySupport: {
    support: 'Support',
  },
  // 文档中心
  documentation: {
    searchPlaceholder: 'キーワードを入力',
    search: '検索',
    type: 'タイプ',
    productFilter: '製品情報',
    solutionFilter: 'ソリューション',
    distributionFilter: '流通業',
    typeFilter: 'シナリオ',
    filters: {
      General: '一般情報',
      AIC: 'AI カメラ',
      VIP: 'ビデオインテリジェントプラットフォーム',
      'IP Camera & NVR': 'IPカメラ&NVR',
      'Analog Camera & XVR': 'アナログカメラ&XVR',
      'Transmission': '伝送',
      'Display & Control': '表示と制御',
      'Entrance & Exit Management': '入退場管理',
      'Public Adress': 'パブリックアドレス',
      'Management System': '管理体制',
      'Accessories': 'アクセサリー',
      'Alarm': 'アラーム',
      'HOLOWITS Selected': 'HOLOWITS厳選',
      'Network Keyboard': 'ネットワークキーボード',
      'Decoder': 'デコーダー',
      'Encoder': 'エンコーダー',
      'LED Display': 'LEDディスプレイ',
      'Access Control': 'アクセス制御',
      'Electric Gate': '電気ゲート',
      'Parking Management': '駐車場管理',
      'Parking Guidance': '駐車場案内',
      'Video Intercom': 'ビデオインターホン',
      'Loudspeaker': '拡声器',
      "Microphone": "マイクロフォン",
      "Intercom Terminal": "インターホンターミナル",
      "Server": "サーバー",
      "Amplifier": "増幅器",
      "Star PA": "スターPA",
      "VMS": "VMS（仮想マシン）",
      "Intelligent Campus": "インテリジェントキャンパス",
      "Intelligent Traffic": "インテリジェントトラフィック",
      "Intelligent City": "インテリジェントシティ",
      "Target Recognition Application": "ターゲット認識アプリケーション",
      "Alarm Host": "アラームホスト",
      "Zone Module": "ゾーンモジュール",
      "Detectors": "検出器",
      "Software": "ソフトウェア",
      "Accesories": "アクセサリー",
      "Power Station": "発電所",
      "Pre-Sales Communication": "販売前のコミュニケーション",
      "After-Sales Service": "アフターサービス",
      "Training": "トレーニング",
      "Marketing": "マーケティング",
      "Bidding": "入札",
      "Partner Operation": "パートナー運営",
      "Datasheet": "データシート",
      "Overview Presentation": "概要プレゼンテーション",
      "Technical Presentation": "技術的なプレゼンテーション",
      "High Level Design": "ハイレベルデザイン",
      "White Paper": "ホワイトペーパー",
      "Sales Guide": "販売ガイド",
      "Competitive Positioning": "競争力のあるポジショニング",
      "Product Sales List": "製品販売リスト",
      "Star Product Introduction": "スター製品紹介",
      "POC Test Guide": "POC試験ガイド",
      "Naming Rules": "命名規則",
      "Analyst Report": "アナリストレポート",
      "Demo Video": "デモビデオ",
      "Deployment Guide": "導入ガイド",
      "User Guide": "ユーザーガイド",
      "Firmware": "ファームウェア",
      "Quick Start Guide": "クイックスタートガイド",
      "Release Note": "リリースノート",
      "Acceptance Guide": "受け入れガイド",
      "Interface Document": "インターフェイスドキュメント",
      "Product Document": "製品ドキュメント",
      "Maintenance Guide": "メンテナンスガイド",
      "Version Mapping": "バージョンマッピング",
      "Product Manual": "製品マニュアル",
      "Pre-Sales": "プリセールス",
      "Post-Sales": "販売後",
      "Presentation": "プレゼンテーション",
      "EDM": "EDM",
      "Product Picture": "製品画像",
      "Advertisement & Poster": "広告・ポスター",
      "Invitation Letter": "招待状",
      "Exhibition Material": "展示会資料",
      "VI & KV": "VI&KV",
      "Promotional Video": "プロモーションビデオ",
      "Product & Solution Video": "製品&ソリューションビデオ",
      "Handbook": "ハンドブック",
      "Rollup": "ロールアップ",
      "News & Advertorial": "ニュース&広告",
      "Brochure & Catalog & Portfolio": "パンフレット&カタログ&ポートフォリオ",
      "Case Study": "ケーススタディ",
      "Authorization Letter": "承認書",
      "JMF": "JMF",
      "Specification List": "仕様一覧",
      "Bidding Guide": "入札ガイド",
      "Configuration Manual": "設定マニュアル",
      "Reliability Prediction Report": "信頼性予測レポート",
      "Quotation Guide": "見積書ガイド",
      "EU Declaration of Conformity": "EU適合宣言書",
      "Compatibility List": "互換性リスト",
      "Award & Qualification": "賞と資格",
      "Technical Proposal Template": "技術提案書テンプレート",
      "Certification and Test Report": "認証とテストレポート",
      "Partner Certification": "パートナー認定",
      "Terms": "利用規約",
      "Warranty": "保証について"
    },
    languageFilter: '言語',
    formatFilter: 'フォーマット',
    publishDate: 'リリース日で並び替え',
    downloadTimes: 'ダウンロード数で並び替え',
    hotDoc: 'ホットドキュメント',
    result: '件',
    download: 'ダウンロード',
    share: 'シェア',
    batDownload: 'Batch Download',
    checkAll: 'Check All',
    paginalNumber: 'ページ数',
    loginTips: 'ログインで追加コンテンツ',
    login: 'ログイン',
  },
  // 视频中心
  videoLibrary: {
    title: 'ビデオ一覧',
    searchVideo: '動画を検索',
    all: 'すべて',
    branding: 'ブランディング',
    products: '製品情報',
    solutions: 'ソリューション',
    technicalSupport: 'テクニカルサポート',
    training: 'トレーニング',
    hOLOWITSClub: 'HOLOWITSクラブ',
    algorithm: 'アルゴリズム',
    technologies: '技術情報'
  },
  faq: {
    faq: 'FAQ',
    Products: 'Products',
    Solutions: 'Solutions',
    Partners: 'Partners',
    Marketing: 'Marketing',
    Others: 'Others',
    placeholder: 'leave blank and you get all FAQs',
    help: 'How to use FAQ search'
  },
  learnRegister: {
    tips: "ヒント",
    note: "注意：試験アカウントを申請する前に、右上の個人アカウントにログインしてください。",
    noteOther: "それ以外の場合、試験アカウントの申請は送信されません。",
    pageTitle: "HOLOWITS認定スペシャリスト試験登録",
    pageDesc1: "下記のフォームにご記入ください。",
    pageDesc2: "確認後、メールをお送りします。",
    hint1: "会社の従業員であることを証明してください（スタッフカードまたは名刺をアップロードできます）",
    hint2: "会社のビジネスライセンスをアップロードしてください（任意）",
    required: "このフィールドは必須です。",
    upload: "アップロード",
    successPanelTitle: "Submitted successfully",
    successPanelText: "The application has been submitted and the administrator will contact you via email.\nIf your company want to become our Certified Tier 2 partner, please click here to register. After one employee of your company passes HOLOWITS Certified Specialist Exam, your company can become our Certified Tier 2 partner and also can be shown our website.",
    inputPlaceholder: "HOLOWITSのスペシャリスト試験に参加する理由を簡単に説明してください"
  },
  register: {
    register: "Register",
    email: "Please input your Employee Email",
    companyName: "Company Full Name",
    name: "Your Name",
    country: "Country/Region",
    description: "Please describe the Partner Type of your company and HOLOWITS",
    code: "Verification Code",
    cancel: "Cancel",
    submit: "Submit",
    successPanelTitle: "Submitted successfully",
    successPanelText: "The application has been submitted and we will contact you via email.",
    back: "Back",
    rules: {
      email: "Email cannot be empty.",
      companyName: "Name cannot be empty.",
      name: "Name cannot be empty.",
      country: "CountryOrRegion cannot be empty.",
      description: "description cannot be empty.",
      code: "code cannot be empty."
    }
  },
  bind: {
    successPanelText: "The application has been submitted and we will contact you via email.",
  },
  reseller: {
    pageTitle: "パートナーになる",
    companyName: "会社名",
    webSite: "公式サイトURL",
    region: "Region",
    coopCountry: "国/地域",
    distributor: "販売代理店",
    preSales: "プリセールスサポートのメールアドレス",
    postSales: "販売後サポートのメールアドレス",
    marketing: "マーケティングサポートのためのメール",
    email: "あなたに連絡するための電子メール",
    companyEmail: "会社のアカウントとして登録するメールアドレス",
    phone: "プリセールスサポートの電話番号",
    address: "会社住所",
    partnerType: "パートナータイプ",
    uploadLog: "会社のロゴの高解像度グラフィックをアップロードします（jpg。またはpng）",
    upload: "アップロードする",
    downlaod: "契約書テンプレートのダウンロード",
    businessLicense: "会社のビジネスライセンスをアップロードしてください（50M以上のファイル）（PDFをサポートしています。png.jpg。jpeg.webp.形式）",
    agreeFieldText: "私は、ホロイッツがホロイッツのウェブサイトに自分の会社を掲載することを許可します。",
    successPanelTitle: "Submitted successfully",
    successPanelText: "The application has been submitted and the administrator will contact you via email.",
    uploadTips: "ファイルをダウンロードして印刷し、関連情報を記入して手で署名してから、スキャンしたファイルのコピーをアップロードしてください。",
  },
  training: {
    documentation: "Documentation",
    "Scenario": "シナリオ",
    "Pre-sales": "プリセール",
    "Post-sales": "販売後",
    "Product": "製品情報",
    "AI Camera": "AIカメラ",
    "IP Camera/Analog Camera": "IPカメラ/アナログカメラ",
    "Video Intelligent Platform": "ビデオインテリジェントプラットフォーム",
    "NVR/XVR": "NVR/XVR",
    "VMS": "VMS（仮想マシン）",
    "Accessories": "アクセサリー",
    "Other": "その他",
    "Solution": "ソリューション",
    "Intelligent Campus": "インテリジェントキャンパス",
    "Intelligent City": "インテリジェントシティ",
    "Intelligent Transportation": "インテリジェント交通",
    "Intelligent Retail": "インテリジェントリテール"
  },
  contactUs: {
    contactUsPricingInfo:'Contact Us Pricing Info',
    contactUs: 'Contact Us',
    options: {
      pricingInfo: 'Pricing/Info',
      serviceRequests: 'Service Requests',
    },
    pricingInfo: {
      Title: 'お問い合わせ',
      Desc1: '以下のフォームにご記入ください。',
      Desc2: 'すぐにご連絡いたします。',
      Mandatory: '必須',
      FirstName: '名',
      LastName: '姓',
      Area: "地域",
      Email: 'メールアドレス',
      Telephone: '電話番号',
      telephonePlaceholder: "市外局番-番号（例）0066-123456",
      CountryRegion: '国/地域',
      Partner: 'パートナー企業',
      PreferLanguage: '言語',
      preference: 'Pleverye言語設定の選択',
      Company: '会社概要',
      company_placeholder: '会社名を入力してください',
      Industry: '業種',
      JobTitle: '役職',
      FavoriteProducts: 'FavoriteProducts',
      Budget: 'Budget',
      BrieflyPlaceholder: '必須：プロジェクトの要件を簡単に記入してください',
      ConfirmText: '私は、HOLOWITSおよびHOLOWITSの認定パートナーから製品、ソリューション、サービス、製品に関する情報を受け取ることに同意します。いつでも退会できることを理解しています。',
      Yes: 'はい',
      No: 'いいえ',
      AgreeText: 'HOLOWITSのプライバシーポリシーと利用規約に従って、HOLOWITSが私の個人情報を使用し、転送することを理解し、同意します',
      PrivacyPolicy: '',
      publictiy: '貴社の従業員1名がホロイッツ認定スペシャリスト試験に合格すると、貴社は当社の認定ティア2パートナーになり、当社のウェブサイトにも掲載されます。',
      TermsOfUse: '',
      And: '',
      placeholder: '入力してください',
      submit: 'ログイン',
      fieldRequired: 'This field is required.',
      emailValidator: {
        'at-error': 'An email address must contain a &quot;@&quot; symbol.',
        'account-letter-forbidden': 'The email name (example: Adam.Smith@abc.com) contains invalid characters.',
        'prevDot-error': 'The email name (example: Adam.Smith@abc.com) must not start or end with a dot or period (“.”).',
        'double-dot-error:': 'Two successive dots or periods (“.”) together is invalid.',
        'domain-error': 'The domain (example: Adam.Smith@abc.com) must contain at least one domain name.',
        'length-error': 'An email address must not exceed 254 characters.',
        'nextLetter-forbidden': 'The domain (example: Adam.Smith@abc.com) contains invalid characters.',
        'nextLine-error': 'The domain (example: Adam.Smith@abc.com) must not start or end with a hyphen (“-“).',
        'account-length-error': 'An email name (example: Adam.Smith@abc.com) must not exceed 63 characters.',
      },
      phoneFormatError: 'Example : Area Code(3-6 DIGITALS, eg.0066)Phone Number'
    },
  },
  algorithm: {
    // label: "ALGORITHM STORE",
    label: "ALGORITHM",
    // pageTitle: "HOLOWITS Algorithm Store",
    pageTitle: "HOLOWITS Algorithm",
    navOptionTag: "Intelligent Algorithm",
    recommendation: "Related products recommendation",
    rd: "リリース日",
    vud: "最終バージョン更新日",
    selectorItemTitle: {
     "Product Application Scenario": "Product Application Scenario",
     "Algorithm Classification": "Algorithm Classification",
     "Applicable Platform": "適用可能なプラットフォーム",
     "Algorithm type": "アルゴリズムの種類"
    },
    tag: {
     "All": "All",
     "Transportation": "Transportation",
     "Government": "Government",
     "Finance": "Finance",
     "Energy": "Energy",
     "Public Security": "Public Security",
     "Personnel Detection": "Personnel Detection",
     "Intelligent Transportation": "Intelligent Transportation",
     "Text Detection": "Text Detection",
     "Behavior Analysis": "Behavior Analysis",
     "Voice Detection": "Voice Detection",
     "Video Analysis": "Video Analysis",
     "Perimeter Events": "Perimeter Events",
     "Event Detection": "Event Detection",
     "Object Detection": "Object Detection",
     "Detection Analysis": "Detection Analysis",
     "SDC": "SDC",
     "HWT-IVS1800": "HWT-IVS1800",
     "HOLOWITS": "HOLOWITS",
     "HOLOWITS SELECTED": "HOLOWITS厳選",
     "OTHER": "OTHER",
     "Third Party": "サードパーティ"
    },
    label: {
     "Subway": "Subway",
     "Highway": "Highway",
     "Railway": "Railway",
     "Airport": "Airport",
     "Public Transport": "Public Transport",
     "Digital Government": "Digital Government",
     "Bank": "Bank",
     "Insurance": "Insurance",
     "Wind Power": "Wind Power",
     "Solar Energy": "Solar Energy",
     "Electric Power": "Electric Power",
     "Gas": "Gas",
     "Water Conservancy": "Water Conservancy",
     "Petroleum": "Petroleum",
     "Forest": "Forest",
     "City Management": "City Management",
     "Fire Detection": "Fire Detection",
     "Manufacturing": "Manufacturing",
     "Agriculture": "Agriculture",
     "Retail": "Retail",
     "Logistics": "Logistics",
     "Service": "Service",
     "Medical Treatment": "Medical Treatment",
     "Catering Industry": "Catering Industry",
     "Tourism": "Tourism",
     "Education": "Education",
     "Campus": "Campus",
     "Family": "Family",
     "Internet of Things(IoT)": "Internet of Things(IoT)",
     "Target Recognition": "Target Recognition",
     "Personnel Attribute Analysis": "Personnel Attribute Analysis",
     "Overall Target Detection": "Overall Target Detection",
     "License Plate detection": "License Plate detection",
     "Vehicle Attribute Detection": "Vehicle Attribute Detection",
     "Non-standard Vehicle Inspection": "Non-standard Vehicle Inspection",
     "Illegal Detection": "Illegal Detection",
     "Vehicle Detection": "Vehicle Detection",
     "Omni-data Structuring": "Omni-data Structuring",
     "OCR": "OCR",
     "Regulation Breach Detection": "Regulation Breach Detection",
     "Crowd Analysis": "Crowd Analysis",
     "Voice Synthesis": "Voice Synthesis",
     "Voice Identification": "Voice Identification",
     "Video Abstract": "Video Abstract",
     "Perimeter Intrusion": "Perimeter Intrusion",
     "Water Pollution Detection": "Water Pollution Detection",
     "Carrying Dangerous Objects": "Carrying Dangerous Objects",
     "Carrying Prohibited Items": "Carrying Prohibited Items",
     "Construction Machinery Detection": "Construction Machinery Detection",
     "Foreign Matter Detection": "Foreign Matter Detection",
     "Wearing Detection": "Wearing Detection",
     "Equipment Status Detection": "Equipment Status Detection",
     "Instrumentation Detection": "Instrumentation Detection",
     "Defect Detection": "Defect Detection",
     "Remote Sensing": "Remote Sensing",
     "Robot": "Robot",
     "X Series": "X Series",
     "M Series": "M Series",
     "C Series": "C Series",
     "D Series": "D Series",
     "HWT-IVS1800": "HWT-IVS1800",
     "Incidents Detection": "Incidents Detection",
     "HOLOWITS": "HOLOWITS",
     "HOLOWITS SELECTED": "HOLOWITS厳選",
     "OTHER": "その他",
     "Vehicle Detection": "Vehicle Detection",
     "Video Synopsis": "Video Synopsis",
    },
    details: {
      "update tips": "Not available, please wait for the update.",
      "Service Provider": "Service Provider",
      "To contact service provider": "To contact service provider",
      "Service Provider Profile": "Service Provider Profile",
      "tips": "Descriptions on the page are provided by service vendors based on their test results. Actual effects may vary depending on application scenarios. For details about comprehensive product capabilities, contact the store operation team.",
      "tags": {
        "Product Details": "Product Details",
        "Associated Product": "Associated Product",
        "Customer Case": "Customer Case",
        "Customer Evaluation": "Customer Evaluation",
        "Support": "Support"
      },
      smallTags: {
        "Parameters": "Parameters",
        "Introduction": "Introduction",
        "Version": "Version",
        "Highlights": "Highlights",
        "Scenario Requirements": "Scenario Requirements",
        "Graphic presentation": "Graphic presentation",
        "Solution with this algorithm": "Solution with this algorithm",
        "Supporting Applications": "Supporting Applications",
        "User Manual": "User Manual"
      }
    }
   },
   terms: {
    bigTitle: "HOLOWITS製品の購入、サポート、サービスに関するポリシー、契約条件をよく理解してください。",
    title1: "技術サポート",
    title2: "HOLOWITS Product Warranty Policy",
    jumpPrompt: "Find the warranty policy",
  },
  announcement: {
    bigTitle: "HOLOWITS製品の購入、サポート、サービスに関するアナウンスをよく理解してください。",
    title1: "お知らせ",
  },
  specialist: {
    register: "Register",
    startLearning: "Start Learning"
  },
  csp: {
    title1: "パートナータイプ",
    title2: "言語", 
    all: "すべて",
    "Comprehensive Distributor": "総合ディストリビューター",
    "Project-based Distributor": "プロジェクトベースのディストリビュータ",
    "Reseller": "リセラー",
    "System Integrator": "システムインテグレーター",
    "Installer": "インストーラー"
  },
  tools: {
    cameras: "カメラ",
    codec: "画像圧縮方式",
    scenario: "Scenario",
    videoResolution: "ビデオ解像度",
    frameRate: "フレームレート",
    superCoding: "Super Coding",
    bitrate: "ビットレート（Kbps）",
    encodingBitRate: "エンコーディングビットレート (Mbit/s)",
    streamChannels: "ストリームチャンネル",
    packetLossRate: "Packet Loss Rate",
    videoBufferingChannels: "Video Buffering Channels",
    singleImageSize: "Single Image Size",
    imagesUploadedPerSecond: "Images Uploaded Per Second",
    reservedBandwidthCoefficient: "予約帯域幅係数",
    uploadVia: "Upload via FTP/SFTP",
    disable: "Disable",
    enable: "Enable",
    calculate: "計算する",
    reset: "リセット",
    calculateRecordingCapacity: "記録容量の計算",
    basis: "基準",
    basisVideo: "ビデオ解像度",
    basisiRate: "エンコーディングビットレート",
    encodingFormat: "エンコーディング形式",
    coefficient: "Bit rate fluctuation coefficient",
    storagePeriod: "保管期間（日）",
    result: "結果",
    forReferenceOnly: "ご参考",
    bandwidthRequired: "必要な帯域幅",
    about: "約",
    viewFormula: "View Formula",
    nvrAccess: "NVRアクセス",
    capacityRequired: "必要容量",
    calculationObject: "計算オブジェクト",
    obj1: "NVRの数",
    obj2: "SDCの数",
    model: "NVRモデル",
    cameradetectionDistance: 'カメラの検出距離を計算する',
    microCheckpoint: "マイクロチェックポイント",
    ePolic: "ePOLICE/チェックポイント",
    recognition: "ターゲット検出/認識",
    resolutionRequirement: "解像度の要件 (px)",
    sensorSize: "センサーサイズ",
    resolution : "解像度 (w)",
    focal: "焦点距離 (mm)",
    installationHeight: "設置高さ (m)",
    numberOfRrequired: "必要なNVRの数",
    numberOfAccessible: "アクセスできるSDCの数",
    resultLabel1: "検出距離（d）",
    tilt: "チルト角度（α）",
    diagram: "ダイアグラム",
    designTool: {
      title1: "IPビデオシステム設計ツール",
      title2: "HOLOWITSカメラがデータベースに追加されました",
      title3: "IPビデオシステム設計ツールを使用すると、次のことが可能になります。",
      small1: "コストを削減し、最適なカメラ設置位置を見つけながら、セキュリティシステムの効率を向上させます。",
      small2: "正確なカメラレンズとセンサーの要件を簡単に計算して、最適なピクセル密度（PPM/PPF）を実現します。",
      small3: "各カメラの識別、認識、観察、検出、監視の各ゾーンをサイトプランに視覚的に表示します。",
      small4: "間取り図をJPEG、PNG、PDF、TIFF、またはAutoCAD DWG図面（Pro）でインポートして、すぐに設計を開始できます。",
      small5: "10,000台以上のカメラモデルのデータベースで、簡単に設計できるように事前設定されたパラメータを備えています。",
      small6: "ビデオアーカイブ構成に必要なネットワーク帯域幅とストレージを推定します。",
      small7: "ケーブルパスを計画し、ケーブル長を計算します。",
      small8: "設計をエクスポートして、提案または作業指示に含めることができます。",
      title4: "ダウンロードするには、次のリンクをクリックします。",
      title5: "カメラのデータベースを更新するには、をクリックしてください。/新しいバージョンを確認してください。/インストール後に同期してください。"
    },
    md5: {
      title1: 'Md5Checker',
      introduce1: 'Md5 Checkerは、複数のファイル/フォルダのMD5チェックサムを管理、計算、検証するための無料、高速、軽量で使いやすいツールです。',
      introduce2: 'MD5 Checkerを使用して、HOLOWITSのウェブサイトでダウンロードしたファームウェアを確認できます。',
      small1: '複数のファイルのMD5チェックサムを一度に計算して表示します。',
      small2: 'MD5チェックサムを使用して、ファイルが変更されているかどうかを簡単に確認します。',
      small3: 'MD5チェックサムを簡単にロード、保存、追加、削除、更新できます。',
      small4: '約300 KBで、インストールは必要ありません（ポータブル）。',
      title2: 'MD5チェックサムとは何ですか？',
      introduce3: 'MD5チェックサム（MD5ハッシュ）は、ファイルのダイジェストの一種です。ファイルに変更が加えられた場合は、バイト単位であっても異なります。',
      introduce4: 'ファイルに変更が加えられている場合は、1バイトであっても異なります。',
      downloadTips: 'ダウンロードするにはリンクをクリックしてください:'
    }
  },
  firm: {
    label: "Firmware Download",
  },
  soft: {
    label: "Software Download",
  },
  newsRoom: {
    label: "ニュースルーム",
    describe: "ニュースとお知らせ、導入実績、その他",
    learnMore: "もっと見る"
  },
  dr: {
    label: "DEAL REGISTRATION",
    subject: "Deal List",
    title: "Search Condition",
    state1: "Approved",
    state2: "Disapproved",
    state3: "To be Approved",
    state4: "Closed",
    state5: "Unclosed",
    state6: "Pending",
    state7: "Done",
    state8: "Cancelled",
    column1: "Project Name",
    column2: "Company Name (Applicant)",
    column3: "Expected Date of Order",
    column4: "Approval Status",
    column5: "Status",
    column6: "Expiration Date",
    column7: "End Customers Name"
  },
  drDetails: {
    subject1: "Deal Info",
    title1_1: "Deal Business Type",
    title1_2: "Project Name",
    title1_3: "Company Name (Applicant)",
    title1_4: "Win Odds (%)",
    title1_5: "Expected Date of Order",
    title1_6: "Public Tender",
    title1_7: "Deal Registration Start From",
    title1_8: "Expiration Date",
    title1_9: "Deal Description",
    title1_10: "Deal Background",
    title1_11: "Channel Manger Email",
    subject2: "Project Progress and Difficulties for help",
    title2_1: "Operation",
    title2_2: "Project Progress",
    title2_3: "Difficulties for help",
    title2_4: "Created Date",
    subject3: "Competitors",
    title3_1: "Operation",
    title3_2: "Competitor Name",
    title3_3: "Competitive Product",
    subject4: "Products",
    title4_1: "Operation",
    title4_2: "Product Type",
    title4_3: "Series",
    title4_4: "Model",
    title4_5: "Estimated Quantity",
    subject5: "Trading Parties",
    title5_1: "End Customers",
    title5_2: "Product Type",
    title5_3: "End Customers Name",
    title5_4: "End Custimer Name(Native)",
    title5_5_1: "First Name",
    title5_5_2: "Country/Region",
    title5_6: "Last Name",
    title5_7: "State",
    title5_8: "Email",
    title5_9: "City",
    title5_10: "Office Phone",
    title5_11: "Town",
    title5_12: "Address",
    title5_13: "Web site",
    title5_14: "Postal Code",
    title5_15: "Phone NO.",
    title5_16: "Industry",
    title5_17: "Sub-industry",
    title5_18: "Distributor",
    title5_19: "Company Name",
    title5_20: "Address",
    title5_21: "Location Name",
    title5_22: "Postal Code",
    title5_23: "City",
    title5_24: "Tier 2 Partner (if have)",
    title5_25: "Company Name",
    title5_26: "Address",
    title5_27: "Location Name",
    title5_28: "Postal Code",
    title5_29: "City",
    subject6: "Partner Sales Team",
    title6_1: "Operation",
    title6_2: "MAIN",
    title6_3: "Partner",
    title6_4: "Company Name",
    title6_5: "Role",
    title6_6: "Name",
    title6_7: "Email",
    title6_8: "Office phone",
    tips1_1: "1) For the purpose of HOLOWITS's provision of related services to you, HOLOWITS will collect Your personal data (including name, email, etc.), the personal data will be stored on the servers of HOLOWITS TECHNOLOGIES PTE. LTD. (HOLOWITS) and its affiliates. It may be processed by HOLOWITS and the relevant third party. It may be transferred to the third party's country/region or to locations separate from those where HOLOWITS collects the information, and will be accessed, stored, and processed in the aforesaid locations .For more details about how HOLOWITS processes the data, please see the Privacy Statement. Privacy Statement. ",
    tips1_2: "2) If the data you enter contains the personal information of a third party, please inform the third party of the above and obtain their consent or authorization, too. ",
    link1: "Privacy Statement.",
    tips2_1: "Request to close the deal",
    tips2_2: "(If you select this option, you will not be able to modify or update the content of this deal after it is closed).",
    submit: "Submit",
  }
};
